// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C7Hp","colBig":"styles_colBig__2dRks","colSmall":"styles_colSmall__2XLlv"};